import PipelineOverviewPage from '../../../components/admin/pipeline/PipelineOverviewPage'
export default function PipelineOverview() { return <PipelineOverviewPage /> }
